import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import SingleBlog from '../../components/Blog';
import Button from '../../components/Button';

import blogImg1 from '../../assets/img/blog/blog-1-1.jpg';
import blogImg2 from '../../assets/img/blog/blog-1-2.jpg';
import blogImg3 from '../../assets/img/blog/blog-1-3.jpg';

const Blog = () => {
  return (
    <div id="it-blog" className="it-blog-area pt-120 pb-90">
      <div className="container">
        <div className="it-blog-title-box mb-65">
          <div className="row align-items-end">
            <div className="col-xl-6 col-lg-6 col-md-6">
              <SectionTitle
                itemClass="it-blog-title-box"
                subTitle="Blog"
                title="Our recent Post"
              />
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6">
              <div className="it-service-button text-md-end">
                <Link className="it-btn-theme mr-30" to="/blog">
                  <Button btnText="All Blog" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleBlog
              blogImage={blogImg1}
              publishedDate="10"
              publishedMonth="March 24"
              authorName="Camsth Smith"
              title="Healthcare Tips Navigating Business Patient Care"
              btnText="Read More"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleBlog
              blogImage={blogImg3}
              publishedDate="21"
              publishedMonth="March 24"
              authorName="Camsth Smith"
              title="Healthcare Tips Navigating Business Patient Care"
              btnText="Read More"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleBlog
              blogImage={blogImg2}
              publishedDate="25"
              publishedMonth="March 24"
              authorName="Camsth Smith"
              title="Healthcare Tips Navigating Business Patient Care"
              btnText="Read More"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
